import { useState, useMemo } from 'react';
import type { InventoryItem } from '../types/inventory';

export function useInventoryFilters(items: InventoryItem[]) {
  const [nameFilter, setNameFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState<'all' | 'active' | 'inactive'>('all');
  const [stockStatusFilter, setStockStatusFilter] = useState<'all' | 'available' | 'low' | 'depleted'>('all');

  const filteredItems = useMemo(() => {
    return items.filter(item => {
      const matchesName = item.name.toLowerCase().includes(nameFilter.toLowerCase()) || 
                          (item.code || '').toLowerCase().includes(nameFilter.toLowerCase());
      
      const derivedStockStatus = (() => {
        const stock = typeof item.stock === 'number' ? item.stock : 0;
        if (stock <= 0) return 'depleted';
        if (item.itemType === 'finished_good') {
          if (stock <= 10) return 'low';
          return 'available';
        }
        const reorderPoint = typeof item.reorderPoint === 'number' ? item.reorderPoint : 0;
        if (reorderPoint > 0 && stock <= reorderPoint) return 'low';
        return 'available';
      })();

      const matchesDbStatus = statusFilter === 'all' || item.status === statusFilter;
      const matchesStockStatus = stockStatusFilter === 'all' || derivedStockStatus === stockStatusFilter;
      return matchesName && matchesDbStatus && matchesStockStatus;
    });
  }, [items, nameFilter, statusFilter, stockStatusFilter]);

  return {
    nameFilter, setNameFilter,
    statusFilter, setStatusFilter,
    stockStatusFilter, setStockStatusFilter,
    filteredItems,
  };
}
